// extracted by mini-css-extract-plugin
export var active = "_lt-2";
export var recordingDot = "_lt-1";
export var recordingIndicator = "_lt-0";